import { EditorState, PluginKey } from 'prosemirror-state'
import { State } from './Types'

export const TODOS_PLUGIN_KEY = new PluginKey<State>('todos')

export function getTodosPluginState(editorState: EditorState) {
  const pluginState = TODOS_PLUGIN_KEY.getState(editorState)
  if (!pluginState) {
    throw new Error('Todos plugin is not registered on the current editor state.')
  }
  return pluginState
}
